import { MetadataTypeEnum } from "build-ts/enums";
import { fetchMetadataHeaders, HeaderWithStats } from "services/MetadataServices";

export type ReportDownloadFormat = "docx" | "pdf";

/**
 * Fetch all analyst headers.
 *
 * @param {boolean} includeStats - include stats in the response.
 * @param {string} searchString - optional text filter applied server-side.
 * @returns {Promise<HeaderWithStats[]>} A promise that resolves to the list of headers.
 * @throws {Error} Throws an error if the request fails.
 */
export const fetchAnalystList = async (
    includeStats: boolean = false,
    searchString: string = "",
): Promise<HeaderWithStats[]> => {
    const response = await fetchMetadataHeaders(
        MetadataTypeEnum.ANALYST,
        -1,             // all analysts
        1,              // page 1
        "LAST_MODIFIED",
        false,          // sort descending
        searchString,
        "",             // no author filter
        [],             // no owner filter
        includeStats,
    );
    return response?.headers ?? [];
};